import Vue from "vue";
import Router from "vue-router";
import store from "./store.js";

function loadView(view) {
  return () =>
    import(/* webpackChunkName: "view-[request]" */ `./pages/${view}.vue`);
}

Vue.use(Router);

const v3Core = loadView("_v3.3");
const v3Meta = {
  version: 3.0,
  promo: false,
  display: {
    web_footer: "hide",
    trends: true,
  },
  // mini: true, // <<-- @Jason - this removes the header & footer (when: true)
};

// const v5Core = loadView('HomeV5');
const v5Meta = {
  version: 5.0,
  promo: false,
  mini: false,
  display: {
    web_footer: "hide",
    body_class: ["clear"],
  },
};

const router = new Router({
  mode: "history",

  // GO TO BOTTOM FOR SCROLL CACHE/BEHAVIOUR

  routes: [
    {
      path: "*",
      name: "not-found",
      component: loadView("404"),
    },

    {
      path: "/dashboard",
      name: "Dashboard",
      component: loadView("v5/dashboard/Dashboard"),
      meta: {
        ...v5Meta,
        fullScreen: true,
        nav: true,
        tab: "dashboard",
        // swiper: true,
      },
    },
    {
      path: "/login",
      name: "Login",
      component: loadView("Section"),
      meta: { promo: false },
    },
    {
      path: "/deck",
      name: "Deck",
      component: loadView("Deck"),
      meta: { promo: false, mini: true },
    },
    // {
    //   path: "/trends/:topics?",
    //   redirect: {
    //     name: "Analyse",
    //   },
    // },
    // {
    //   path: "/weekly",
    //   name: "OneSub - Weekly",
    //   component: loadView("weekly/Weekly"),
    //   meta: { promo: false },
    // },

    // {
    //   path: "/analyse/working",
    //   name: "Working",
    //   component: loadView("Analysing"),
    //   meta: { promo: false },
    // },
    // {
    //   path: "/analyse/covid",
    //   name: "Analysing",
    //   component: loadView("AnalysingCovid"),
    //   meta: { promo: false },
    // },
    // {
    //   path: "/analyse/retry",
    //   name: "Analysing Reload",
    //   component: loadView("AnalysingReload"),
    //   meta: { promo: false },
    // },

    {
      path: "/account",
      component: loadView("Account"),
      meta: {
        promo: false,
        tab: "profile",
      },
      children: [
        {
          path: "",
          component: loadView("account/Communication"),
          meta: { tab: "profile" },
        },
        {
          path: "signin",
          component: loadView("account/Details"),
          meta: { tab: "profile" },
        },
        {
          path: "communication",
          component: loadView("account/Communication"),
          meta: { tab: "profile" },
        },
        {
          path: "threads",
          component: loadView("account/Threads"),
          meta: { tab: "profile" },
        },
        {
          path: "pro",
          component: loadView("account/Pro"),
          meta: { tab: "profile" },
        },
        {
          path: "manage",
          component: loadView("account/Manage"),
          meta: { tab: "profile" },
        },
        {
          path: "debug",
          component: loadView("account/Debug"),
          meta: { tab: "profile" },
        },
      ],
    },
    {
      path: "/account/stripe/done",
      name: "Account Stripe",
      component: loadView("AccountStripe"),
      meta: { promo: false },
    },
    {
      path: "/tools/stories",
      name: "Tools: Story Merge",
      component: loadView("ToolsStories"),
      meta: { promo: false },
    },

    // --------------- MY STORY / MY PAPER / ONEPAPER -----------------
    {
      path: "/share",
      name: "Share, Create & Bookmark with OneSub",
      component: loadView("Share"),
      meta: { promo: false, mini: true },
    },
    {
      path: "/invite",
      redirect: {
        name: "Profile Invite",
      },
    },
    {
      path: "/~:xname?/invite",
      name: "Profile Invite",
      component: loadView("v5/profile/Invite"),
      meta: {
        promo: false,
        tab: "profile",
        // mini: true,
        display: {
          web_footer: "hide",
        },
      },
    },
    {
      path: "/~:xname/:slug/:clip?",
      name: "Create, Share & Bookmark Intelligently",
      component: loadView("Thread"),
      meta: { promo: false },
    },
    {
      path: "/~:xname",
      name: "Create, Share & Bookmark intelligently with OneSub",
      component: loadView("ThreadList"),
      meta: { promo: false },
    },

    // --------------- HAND BUILT LANDERS -----------------
    {
      path: "/mission",
      name: "Mission",
      component: loadView("v5/Mission"),
      meta: { promo: false },
    },
    // {
    //   path: "/influencers",
    //   name: "Influencers",
    //   component: loadView("Influencers"),
    // },

    {
      path: "/threads*", // wildcarded for ad campaigns & OG variation /threads/clip-thread-share etc.
      name: "Threads",
      component: loadView("Threads"),
      meta: { promo: false },
    },
    {
      path: "/support",
      name: "Support Nourish",
      component: loadView("v5/Support"),
      meta: { promo: false },
    },
    {
      path: "/contact",
      name: "Contact Nourish",
      component: loadView("v5/Contact"),
      meta: { promo: false },
    },
    {
      path: "/charlie",
      name: "Nourish Search",
      component: loadView("v5/NourishSearch"),
      meta: { promo: false },
    },

    // {
    //   path: "/blog",
    //   name: "Blog",
    //   component: loadView("v5/blog/Blog"),
    //   meta: { promo: false },
    // },

    // {
    //   path: "/blog/article",
    //   name: "Blog Article",
    //   component: loadView("v5/blog/Article"),
    //   meta: { promo: false },
    // },

    {
      path: "/",
      name: "OneSub",
      component: loadView("_v6_news"),
      meta: {
        desk: true,
        ...v5Meta,
      },
    },


    /** HACK! */
    {
      path: "/:section(politics|business|sport|culture|science-and-tech|environment|society)",
      name: "Section",
      component: loadView("_v6_news"),
      meta: {
        desk: true,
        ...v5Meta,
      },
    },











    {
      path: "/collections/preview/:slug",
      name: "preview",
      component: loadView("_v6_news"),
      meta: {
        desk: true,
        ...v5Meta,
      },
    },

    {
      path: "/n/:slug?/:stack?",
      name: "n/Stack",
      // component: loadView("v5/Swipe"),
      component: loadView("_v6_news"),
      // meta: {
      //   tab: "home",
      //   swiper: true,
      //   display: {
      //     web_footer: "hide",
      //   },
      // },
      meta: {
        swiper: true, // put back in (for tabbar reveal -- BUT -- watch it doesn't fuck things up.. )
        desk: true,
        ...v5Meta,
      },
    },

    // {
    //   path: "/topic/:topic",
    //   name: "Topic",
    //   component: loadView("_v6_news"),
    //   meta: v5Meta,
    // },

    // --------------- v3 - LEGACY! -----------------

    // {
    //   path: "/:mode(story)/:slug/v3",
    //   name: "Story v3",
    //   component: v3Core,
    //   meta: {
    //     ...v3Meta,
    //     mode: "story", // masks the /story hardcoding during transition
    //   },
    // },
    {
      path: "/:mode(story)/:slug/",
      name: "Story",
      component: v3Core,
      meta: {
        ...v3Meta,
        mode: "story", // masks the /story hardcoding during transition
        // swiper: true, // 28 Jul - removed, cos we're really not?  What relies on this?
        nav: true,
        fullScreen: true,
        display: {
          web_footer: "hide",
          // tab_bar: "hide",
        },
      },
    },
    {
      path: "/:mode(story)/:slug/:node?/:card?",
      name: "Article",
      component: v3Core,
      meta: {
        ...v3Meta,
        mode: "story", // masks the /story hardcoding during transition
        // swiper: true, // 28 Jul - removed, cos we're really not?  What relies on this?
        nav: true,
        fullScreen: true,
        display: {
          web_footer: "hide",
          // tab_bar: "hide",
        },
      },
    },
    // {
    //   path: "/section/:name",
    //   name: "Section",
    //   component: loadView("Section"),
    //   meta: { promo: true },
    // },

    {
      path: "/mine",
      name: "Mine",
      component: loadView("Mine"),
      meta: {
        ...v5Meta,
        tab: "home",
      },
    },

    {
      path: "/search",
      name: "Search",
      component: loadView("Search"),
      meta: {
        ...v5Meta,
        // swiper: true, // 28 Jul - removed, cos we're really not?  What relies on this?
        nav: true,
        tab: "search",
      },
    },

    /* -----------------------------------------------------------------------
		v5 - Topics
		----------------------------------------------------------------------- */
    {
      path: "/topics/:subgroup?",
      name: "Topics",
      component: loadView("Topics"),
      meta: {
        promo: false,
        tab: "explore",
        fullScreen: true,
        // swiper: true, // 28 Jul - removed, cos we're really not?  What relies on this?
        nav: true,
        display: {
          web_footer: "hide",
        },
      },
    },
    {
      path: "/topic/:name",
      name: "Topic",
      component: loadView("Topic"),
      meta: {
        promo: false,
        tab: "explore",
        fullScreen: true,
        // swiper: true, // 28 Jul - removed, cos we're really not?  What relies on this?
        nav: true,
        display: {
          web_footer: "hide",
        },
      },
    },

    /* -----------------------------------------------------------------------
		v5 - Open
		----------------------------------------------------------------------- */
    {
      path: "/open",
      component: loadView("Open"),
      meta: { promo: false },
      children: [
        {
          path: "",
          name: "OneSub - Open",
          component: loadView("landers/Open"),
          meta: { pormo: false },
        },
        {
          path: "trends/:topics?",
          name: "Analyse",
          component: loadView("Analyse"),
          meta: { promo: false },
        },
        {
          path: "publishers",
          name: "Publishers",
          component: loadView("OpenPublishers"),
          meta: { promo: false },
        },
        {
          path: "status",
          name: "Status",
          component: loadView("OpenStatus"),
          meta: { promo: false },
        },
        {
          path: "status/clean",
          name: "Status Clean",
          component: loadView("OpenStatus"),
          meta: { promo: false, mini: true },
        },
        {
          path: "tracking",
          name: "Tracking",
          component: loadView("OpenTracking"),
          meta: { hideSubNav: true },
        },
      ],
    },

    {
      path: "/answers",
      name: "AnswersLander",
      component: loadView("AnswersLander"),
      meta: {
        ...v5Meta,
        nav: true,
        // swiper: true, // 28 Jul - removed, cos we're really not?  What relies on this?
      },
    },

    {
      path: "/answers/:slug/:seo?",
      name: "Answer",
      component: loadView("Answers"),
      meta: {
        ...v5Meta,
        nav: true,
        // swiper: true, // 28 Jul - removed, cos we're really not?  What relies on this?
      },
    },

    {
      path: "/article/:article",
      name: "Article",
      component: loadView("Article"),
      meta: {
        fullScreen: true,
        display: {
          web_footer: "hide",
        },
      },
    },

    {
      path: "/puzzles/emoji/:slug?",
      name: "PuzzlesEmoji",
      component: loadView("PuzzlesEmoji"),
      meta: {
        mini: true,
        display: {
          web_footer: "hide",
        },
      },
    },

    {
      path: "/video/:slug?",
      name: "Video Tools",
      component: loadView("Video"),
      meta: {
        promo: false,
        mini: true,
      },
    },

    /* -----------------------------------------------------------------------
		v5 Routes
		----------------------------------------------------------------------- */
    {
      path: "/helpers/topic-svg",
      name: "helpers/TopicSVG",
      component: loadView("v5/helpers/TopicSVG"),
      meta: {
        mini: true,
        display: {
          web_footer: "hide",
        },
      },
    },

    // {
    //   path: "/new",
    //   name: "v5/Lander",
    //   component: loadView("v5/Lander"),
    //   meta: {
    //     mini: true,
    //     display: {
    //       web_footer: "hide",
    //       tab_bar: "hide",
    //     },
    //   },
    // },

    // {
    //   path: "/d/:slug?/:stack?",
    //   name: "d/Stack",
    //   component: loadView("v5/Desktop"),
    //   meta: {
    //     tab: "home",
    //     // mini: true,
    //     display: {
    //       web_footer: "hide",
    //       tab_bar: "hide",
    //     },
    //   },
    // },
    {
      path: "/debug/stacks/:stack?",
      name: "DebugStacks",
      component: loadView("v5/Debug"),
      meta: {
        tab: "home",
        mini: true,
        display: {
          web_footer: "hide",
          tab_bar: "hide",
        },
      },
    },

    {
      path: "/debug/base64-image",
      name: "DebugAndroidImage",
      component: loadView("v5/debug/base64image"),
      meta: {
        tab: "home",
        mini: true,
        display: {
          web_footer: "hide",
          tab_bar: "hide",
        },
      },
    },

    {
      path: "/vue-og/avatar",
      component: loadView("v5/og/Avatar"),
      meta: {
        mini: true,
        display: {
          web_footer: "hide",
          tab_bar: "hide",
        },
      },
    },

    {
      path: "/vue-og/profile/:handle",
      component: loadView("v5/og/Profile"),
      meta: {
        mini: true,
        display: {
          web_footer: "hide",
          tab_bar: "hide",
        },
      },
    },
    {
      path: "/vue-og/stacks/email/five-a-day",
      component: loadView("v5/og/FiveADay"),
      meta: {
        mini: true,
        display: {
          web_footer: "hide",
          tab_bar: "hide",
        },
      },
    },
    {
      path: "/vue-og/stack/:slug/:card?/:foo?",
      component: loadView("v5/og/Stack"),
      meta: {
        mini: true,
        display: {
          web_footer: "hide",
          tab_bar: "hide",
        },
      },
    },
    {
      path: "/generator/video/:stack",
      component: loadView("v5/generator/Video"),
      meta: {
        mini: true,
        display: {
          web_footer: "hide",
          tab_bar: "hide",
        },
      },
    },
    {
      path: "/generator/long/:stack/:slug?",
      component: loadView("v5/generator/LongForm"),
      meta: {
        mini: true,
        display: {
          web_footer: "hide",
          tab_bar: "hide",
        },
      },
    },
    {
      path: "/generator/story/:slug",
      component: loadView("v5/generator/StoryVideo"),
      meta: {
        mini: true,
        display: {
          web_footer: "hide",
          tab_bar: "hide",
        },
      },
    },
    {
      path: "/generator/subs",
      component: loadView("v5/generator/Subtitles"),
      meta: {
        mini: true,
        display: {
          web_footer: "hide",
          tab_bar: "hide",
        },
      },
    },

    {
      path: "/generator/social/:topic",
      component: loadView("v5/generator/Social"),
      meta: {
        mini: true,
        display: {
          web_footer: "hide",
          tab_bar: "hide",
        },
      },
    },

    {
      path: "/about",
      component: loadView("v5/About"),
      meta: {
        ...v5Meta,
      },
    },
  ],

  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 };
  },

  // scrollBehavior() {
    // console.log(`ScrollBehaviour disabled: `, to);

    // Ignore for now
    // return;

    // -----------------------------------------------------------------------------------
    // Handle scroll position history for tabs
    // @Jim: Below is what I added recently to try and fix the scroll position that I described in the slack thread

    // let tabHistory = store.getters.getTab(to.path);
    // console.log(
    //   `\x1b[32m[Scroll] Retrieve: '${to.path}' : `,
    //   tabHistory,
    //   tabHistory?.pos?.y
    // );

    // return new Promise((resolve) => {
    //   Vue.nextTick(() => {
    //     const y = tabHistory?.pos?.y ?? 0;
    //     window.scrollTo(0, y);
    //     resolve({ x: 0, y });
    //   });
    // });
    // -----------------------------------------------------------------------------------

    // // IGNORE STORY-NODE scrolling!!
    // // console.log(`\x1b[32m[Scroll] To: '${to.path}' : `, to);
    // if (to.params.mode == "story" && to.params.slug && to.params.node) {
    //   // console.log(`\x1b[32m[Scroll] Ingore Story Nodes! ... : '${to.path}' : `);
    //   return;
    // }
    // if (to.meta.swiper) {
    //   return { y: 0, behavior: "instant" };
    // }
    // if (tabHistory?.pos) {
    //   let iNow = new Date().getTime();
    //   if (tabHistory?.time && iNow - tabHistory?.time > 60 * 5 * 1000) {
    //     // console.log(`\x1b[32m[Scroll] Stale: '${to.path}' : `, (iNow - tabHistory?.time));
    //     return { y: 0, behavior: "instant" };
    //   }
    //   // console.log(`\x1b[32m[Scroll] Positioning!: '${to.path}', x:${tabHistory?.pos?.y}`);
    //   return { y: tabHistory?.pos?.y || 0, behavior: "instant" };
    // }
    // // default
    // // console.log(`\x1b[32m[Scroll] NEW!: '${to.path}'`);
    // return { y: 0, behavior: "instant" };
  // },
});

router.historyCount = 0;
Vue.prototype.$historyCount = () => router.historyCount;


router.beforeEach((to, from, next) => {

  if (from.name) {
    router.historyCount++;
  }

  // clear any 404s (cos we're navigating away from the 404)
  if (router.historyCount) {
    // but not on the initial request!
    store.commit("setHttpStatus", 200);
  }

  // **ALWAYS** store... because exluding '0' means never resetting..
  // console.log(`\x1b[32m[Scroll] Store: `, from.path, window.scrollY);
  store.commit("setTab", {
    code: from.path,
    time: new Date().getTime(),
    pos: {
      y: window.scrollY,
    },
  });

  /**
   * tidy paths we want to treat as the same..
   */

  // remove 'node' from story pages
  // let sTo = to.path.replace(/(?<=\/story\/[a-z0-9]{16}).*/, "");
  // let sFrom = from.path.replace(/(?<=\/story\/[a-z0-9]{16}).*/, "");
  let sTo = to.path.replace(/(\/story\/[a-z0-9]{16}).*/, "$1");
  let sFrom = from.path.replace(/(\/story\/[a-z0-9]{16}).*/, "$1");

  // console.log(`\x1b[32m[History] Store: ${sFrom} -> ${sTo}`);

  if (sTo != sFrom) {
    store.commit("setNavHistory", {
      code: from.path,
    });
  }

  if (to.path.startsWith("/account")) {
    if (store.getters.getToken === "") {
      return next("/");
    }
  }

  // handle the iFrame hack (layoutEngine.js)
  // Vue.prototype.EventBus.$emit("router:beforeEach", { to: to, from: from });

  next();
});

export default router;
